import React, { useEffect, useMemo, useState } from 'react';
import { getLeftMenus } from '../../../../api/managerApi';
import '../leftMenu.css';

const activeBadge = (value) => {
  const isActive = value === true || value === 1 || value === '1' || value === 'true';
  return <span className={`mgr-badge ${isActive ? 'mgr-badge-active' : 'mgr-badge-inactive'}`}>{isActive ? '활성' : '비활성'}</span>;
};

function ValueRow({ label, children }) {
  return (
    <tr>
      <th>{label}</th>
      <td>{children}</td>
    </tr>
  );
}

function LeftMenuItemDetail({ item, onEdit, onDelete }) {
  const [categoryMenus, setCategoryMenus] = useState([]);
  const [selectedMenuId, setSelectedMenuId] = useState('');

  useEffect(() => {
    getLeftMenus()
      .then((rows) => {
        const categories = (Array.isArray(rows) ? rows : []).filter((menu) => menu.type === 'category');
        setCategoryMenus(categories);
      })
      .catch((err) => {
        console.error('카테고리 메뉴 조회 실패:', err);
      });
  }, []);

  useEffect(() => {
    if (!item) return;
    setSelectedMenuId(String(item.menu_id || ''));
  }, [item]);

  const selectedMenuLabel = useMemo(() => {
    const selected = categoryMenus.find((menu) => String(menu.menu_id) === String(selectedMenuId));
    return selected?.label || '-';
  }, [categoryMenus, selectedMenuId]);

  if (!item) return <div className="mgr-right-empty"><span>하위메뉴를 선택하세요.</span></div>;

  return (
    <>
      <div className="mgr-panel-header">
        <div>
          <div className="mgr-panel-title">하위메뉴 조회</div>
          <div className="mgr-panel-subtitle">상위 메뉴: {selectedMenuLabel}</div>
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-sm btn-outline-primary" onClick={() => onEdit && onEdit(item)}>수정</button>
          <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete && onDelete(item)}>삭제</button>
        </div>
      </div>
      <div className="mgr-panel-body">
        <table className="mgr-detail-table">
          <tbody>
            <ValueRow label="라벨">{item.label || '-'}</ValueRow>
            <ValueRow label="경로 (path)">{item.path || '-'}</ValueRow>
            <ValueRow label="URL">{item.url || '-'}</ValueRow>
            <ValueRow label="액션 (action)">{item.action || '-'}</ValueRow>
            <ValueRow label="정렬 순서">{item.sort_order ?? '-'}</ValueRow>
            <ValueRow label="활성 상태">{activeBadge(item.is_active)}</ValueRow>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default LeftMenuItemDetail;
